import Header from './components/Header';
import HeroSection from './components/HeroSection';
import HookSection from './components/HookSection';
import WhyThisMatters from './components/WhyThisMatters';
import YanikQuote from './components/YanikQuote';
import IntroSection from './components/IntroSection';
import PartnershipSession from './components/PartnershipSession';
import ConsultingSimple from './components/ConsultingSimple';
import FAQSection from './components/FAQSection';
import TestimonialsSection from './components/TestimonialsSection';
import ConsultingApplication from './components/ConsultingApplication';
import MeetBrooke from './components/MeetBrooke';
import StayConnected from './components/StayConnected';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <HookSection />
      <WhyThisMatters />
      <YanikQuote />
      <IntroSection />
      <PartnershipSession />
      <ConsultingSimple />
      <FAQSection />
      <TestimonialsSection />
      <MeetBrooke />
      <StayConnected />
      <Footer />
    </div>
  );
}